import * as React from 'react'
import { TextInput } from 'react-admin'
import { TwoColumnInput } from 'shared/molecules/TwoColumnInput'

import slackLogo from './mdi-slack.svg'

const Inputs = (props) => (
  <>
    <TwoColumnInput title="Webhook URL" description="Generated in your Slack channel settings.">
      <TextInput {...props} source="config.webhook_url" label="Webhook" />
    </TwoColumnInput>
    <TwoColumnInput
      title="Channel Name (optional)"
      description="Input the channel name you’d like this notification to go to."
    >
      <TextInput {...props} source="config.channel" label="Channel" />
    </TwoColumnInput>
  </>
)

// https://iconify.design/icon-sets/mdi/slack.html
export default class SlackChannelType {
  static Name = 'Slack'
  static Icon = slackLogo
  static Inputs = Inputs
  static summaryFor(channel) {
    return `Slack messages to #${channel?.config?.channel || 'unknown_channel'}`
  }
}
